import React, { useState } from "react";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import { getBanner } from "./../../../store/banner.reducers";
import { getEventDetails } from "./../../../store/event.details.reducers";
import { getDate, getDateByTimeZoneCba } from "./../../../services/functions";

import Header from "./../../../components/Header";
import Featured from "./../../../components/Featured";
import Title from "./../../../components/Title";
import MainServices from "./../../../components/MainServices";
import Newsletter from "./../../../components/Newsletter";
import Footer from "./../../../components/Footer";
import Share from "./../../../components/Share";

import Gallery from "./Gallery";

import {
  Main,
  Container,
  Content,
  Aside,
  ContentBody,
  ContentMain,
  ContentFigure,
  ContentBox,
  ContentTitle,
  ContentSummary,
  ContentLine,
  ContentZoom,
  ZoomPlus,
  ZoomLess,
} from "./styles";

const frontload = async props => {
  await props.getEventDetails(`${process.env.REACT_APP_API}/events/uri/${props.match.params.uri || ""}`, {}, props.history);
  return;
};

function Details() {
  let { eventDetailsReducers: details } = useSelector(state => state);
  details = details.eventDetails;

  const [fontSize, setFontSize] = useState(0);

  return (
    <>
      <Helmet>
        <title>{details.title}</title>
        <meta name="description" content={details.summary} />
        <meta property="og:title" content={details.title} />
        <meta name="title" content={details.title} />
        <meta property="og:description" content={details.summary} />
        <meta property="og:image" content={details.image_path} />
        <meta property="og:site_name" content="CROMT" />
        <meta property="og:url" content={global.window ? global.window.location : ""} />
      </Helmet>
      <Header />

      <Main id="main">
        <Container>
          <Content>
            <Title title={`${details.title}`} />
            <ContentMain>
              <Aside>
                <MainServices />
              </Aside>

              <ContentBody>
                <ContentFigure title={details.title} alt={details.title}>
                  <Gallery images={details.images} />
                </ContentFigure>

                <ContentBox>
                  <ContentZoom>
                    <ZoomPlus onClick={() => setFontSize(fontSize + 1)}>A+</ZoomPlus>
                    <ZoomLess onClick={() => setFontSize(fontSize - 1)}>A-</ZoomLess>
                    <Share />
                  </ContentZoom>
                  <ContentLine fontSize={fontSize}>{getDateByTimeZoneCba(details.date, "dd 'de' MMMM 'de' yyyy")}</ContentLine>
                  <ContentTitle fontSize={fontSize}>{details.title}</ContentTitle>
                  <ContentSummary
                    fontSize={fontSize}
                    dangerouslySetInnerHTML={{
                      __html: details.summary || "",
                    }}></ContentSummary>
                </ContentBox>
              </ContentBody>
            </ContentMain>
          </Content>
        </Container>
        <Newsletter />
      </Main>
      <Footer />
    </>
  );
}

// export default Home
const mapStateToProps = state => {
  return {
    banner: state.bannerReducers.banner,
    eventDetails: state.eventDetailsReducers.eventDetails,
  };
};
const mapDispatchToProps = {
  getBanner,
  getEventDetails,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(Details),
);
